import { Box, Skeleton } from "@mui/material";
import { useState } from "react";
import { imageStyle } from "./style";
import PropTypes from "prop-types";

const TakaImage = ({ src, alt, isNavbarOpen, isWebplayerTemplate = false }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const classes = imageStyle({ isImageLoaded, isNavbarOpen });
  return (
    <>
      <Box
        className={classes.imageContainer}
        visibility={!isWebplayerTemplate ? "visible" : "hidden"}
      >
        {!isImageLoaded && (
          <Skeleton variant="rectangular" className={classes.imageSkeleton}>
            <div
              data-testid="img-skeleton"
              className={classes.image}
              style={{
                height: "100px",
              }}
            />
          </Skeleton>
        )}
      </Box>
      <Box
        className={classes.imageContainer}
        visibility={!isWebplayerTemplate ? "visible" : "hidden"}
      >
        <img
          className={classes.image}
          onLoad={() => setIsImageLoaded(true)}
          src={src}
          alt={alt}
        />
      </Box>
    </>
  );
};

export default TakaImage;

TakaImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  isNavbarOpen: PropTypes.bool.isRequired,
  isWebplayerTemplate: PropTypes.bool,
};
